export default __webpack_public_path__ + "./images/jm.8a04ad86.png";